export class Cuenta_sueldo{
    constructor(
        public numero_cuenta: String,
        public nombre_cuenta: String

    ){}
}